import { Pin } from "@vis.gl/react-google-maps";

export const MarkerUI = ({ entityType, driverNumber, useDriverIcon }) => {
  switch (entityType) {
    case "orders":
      return (
        <div
          style={{
            position: "relative",
            width: "0px",
            height: "0px",
          }}
        >
          <div
            style={{
              width: "9px",
              height: "9px",
              background: "#F75E00",
              borderRadius: "50%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 3,
            }}
          ></div>

          <div
            style={{
              width: "30px",
              height: "30px",
              background: "rgba(255, 136, 0, 0.4)",
              borderRadius: "50%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}
          ></div>

          <div
            style={{
              width: "60px",
              height: "60px",
              background: "rgba(255, 136, 0, 0.15)",
              borderRadius: "50%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
            }}
          ></div>
        </div>
      );
    case "drivers":
      return (
        <div style={{ position: "relative", width: "0px", height: "0px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#F75E00",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid white",
              boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
            }}
          >
            {useDriverIcon ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="white"
                width="22"
                height="22"
              >
                <path d="M19 7c0-1.1-.9-2-2-2h-3l2 3h-3.5l-1.9-2.7c-.3-.4-.8-.7-1.3-.7C8.8 4.6 8 5.4 8 6.4V10H5c-2.2 0-4 1.8-4 4s1.8 4 4 4c1.9 0 3.5-1.3 3.9-3H13c.4 1.7 1.9 3 3.8 3 2.2 0 4-1.8 4-4l-1.8-3zM5 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm11.8 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
              </svg>
            ) : (
              <span style={{ color: "white", fontWeight: "bold", fontSize: "14px" }}>
                {driverNumber || "?"}
              </span>
            )}
          </div>
        </div>
      );
    case "outlets":
      return (
        <div
          style={{
            position: "relative",
            width: "0px",
            height: "0px",
          }}
        >
          <Pin background={"#F75E00"} borderColor={"#F75E00"} scale={1.0}>
            <img
              src="/assets/outlet-marker3.png"
              alt=""
              className="h-full w-full scale-125"
            />
          </Pin>
        </div>
      );
    case "hubspots":
      return (
        <div
          style={{
            position: "relative",
            width: "0px",
            height: "0px",
          }}
        >
          <Pin background={"#b31412"} borderColor={"#b31412"} scale={1.0}></Pin>
        </div>
      );
    default:
      return null;
  }
};
